// Place all the behaviors and hooks related to the matching controller here.
// All this logic will automatically be available in application.js.
(function() {

$(document).on("turbo:load", function() {

  if ($("#expense_user_id").is(':visible')) {
    $("#expense_user_id").select2({placeholder: "担当弁護士"});
  }

  if ($("#expense_matter_id").is(':visible')) {
    $("#expense_matter_id").select2({placeholder: "依頼人：事件名", allowClear: true});
    // 事件選択時に関連弁護士プルダウンを更新
    new Select2Cascade($('#expense_matter_id'), $('#expense_payer_id'), '/matters/:parentId:/matter_users', {});
  }

  $('#expense_payer_id').select2({allowClear: true});

  $('#expense_amount').on('change', expense_calc);
  $('input[name=expense\\[consumption_tax\\]]:radio').on('change', expense_calc);
  $('input[name=expense\\[tax_withhold\\]]:radio').on('change', expense_calc);
  $('input[name=expense\\[with_invoice\\]]:radio').on('change', expense_calc);
  $('input[name=expense\\[with_invoice\\]]:radio').on('change', expense_invoice_number_visibility);
  expense_calc();
});

const expense_invoice_number_visibility = function() {
  const with_invoice = $('input[name=expense\\[with_invoice\\]]:checked').val();
  if (with_invoice === 'true') {
    $('#expense_invoice_number').show();
  } else {
    $('#expense_invoice_number').val('');
    $('#expense_invoice_number').hide();
  }
};

const expense_calc = function() {
  const amt = Math.round($("#expense_amount").val());
  if ($.isNumeric(amt)) {
    let base_price, deductible, tax, tax_rate, withholding_amount;
    if ($('input[name=expense\\[tax_withhold\\]]:checked').val() === 'withhold_yes') {
      // Reverse calculation
      let tmp_base;
      tax_rate = get_tax_rate();

      // Threshold for 1,000,000 base price (approx 997,900 amount with 10% tax)
      // Threshold depends on tax rate.

      const threshold = 1000000 * ((1 + tax_rate) - 0.1021);

      if (amt > threshold) {
        tmp_base = Math.round((amt - 102100) / ((1 + tax_rate) - 0.2042));
      } else {
        tmp_base = Math.round(amt / ((1 + tax_rate) - 0.1021));
      }

      tax = Math.floor(tmp_base * tax_rate);
      withholding_amount = calc_with_holding_tax(tmp_base);
      base_price = (amt + withholding_amount) - tax;

      deductible = expense_deductible_calc(tax);
    } else {
      // Standard calculation (tax inclusive)
      tax_rate = get_tax_rate();
      base_price = Math.round(amt / (1 + tax_rate));
      tax = amt - base_price;
      deductible = expense_deductible_calc(tax);
      withholding_amount = 0;
    }

    $('#expense_base_price').first().val(base_price);
    $('#expense_deductible').first().val(deductible);
    $('#expense_withholding_amount').val(withholding_amount);
    $('#expense_consumption_tax_amount').val(tax);
  }
};

const get_tax_rate = function() {
  const tax_rate_str = $('input[name=expense\\[consumption_tax\\]]:checked').val();
  if (tax_rate_str === 'ten') {
    return 0.1;
  }
  if (tax_rate_str === 'eight') {
    return 0.08;
  }
  return 0;
};

const expense_deductible_calc = function(tax) {
  const with_invoice = $('input[name=expense\\[with_invoice\\]]:checked').val();
  if (with_invoice === 'true') {
    return Math.round(tax);
  } else {
    return Math.round(tax * 0.8);
  }
};

const calc_with_holding_tax = function(amt) {
  if ($('input[name=expense\\[tax_withhold\\]]:checked').val() === 'withhold_no') {
    return 0;
  }
  if (amt <= 1000000) {
    return Math.floor(amt * 0.1021);
  } else {
    return Math.floor(((amt - 1000000) * 0.2042) + 102100);
  }
};

})();
